import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { RoleService } from 'src/app/private/services/role.service';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-create-role',
  imports: [SharedModule, ToggleButtonModule],
  templateUrl: './create-role.component.html',
  styleUrl: './create-role.component.scss'
})
export class CreateRoleComponent {
  @Input() clientId!: string;
  @Input() type: string = 'Create'; // 'create' or 'edit'
  @Input() roleDataToEdit: any = null; // To hold the role data to be edited
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  loading: boolean = false;
  submitted: boolean = false;
  permissionForm!: FormGroup;
  permissionsData:any[] = [
  {
    "id": 1,
    "title": "Dashboard",
    "module_name": "dashboard",
    "active": false,
    "features": [
      {
        "title": "Analytics",
        "name": "analytics",
        "active": true,
        "update": false,
        "create": false,
        "delete": false
      },
      {
        "title": "Leads",
        "name": "lead",
        "active": true,
        "update": true,
        "create": false,
        "delete": false
      },
      {
        "title": "User Logs",
        "name": "user_log",
        "active": true,
        "update": true,
        "create": false,
        "delete": false
      }
    ]
  },
  {
    "id": 2,
    "title": "Leads",
    "module_name": "lead",
    "active": true,
    "features": [
      {
        "title": "Manual",
        "name": "manual",
        "active": true,
        "communication":true,
          "communication_logs":true,
          "tasks":true,
          "mettings":true,
          "notes":true,
          "convert_account":true,
          "bulk_filter":true,
        "update": true,
        "create": true,
        "delete": true,
        "import": true,
        "export": true
      }
    ]
  },
  {
    "id": 3,
    "title": "Events",
    "module_name": "event",
    "active": true,
    "features": [
      {
        "title": "Events",
        "name": "event",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
   {
    "id": 13,
    "title": "Sales Mail Hub",
    "module_name": "sales-mail-hub",
    "active": true,
    "features": [
      {
        "title": "Sales Mail Hub",
        "name": "sales-mail-hub",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 25,
    "title": "Woocommerce",
    "module_name": "woocommerce",
    "active": true,
    "features": [
      {
        "title": "Woocommerce",
        "name": "woocommerce",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Woo-orders",
        "name": "woo-orders",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Woo-products",
        "name": "woo-products",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 20,
    "title": "Tickets",
    "module_name": "tickets",
    "active": true,
    "features": [
      {
        "title": "Tickets",
        "name": "tickets",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 21,
    "title": "Deals",
    "module_name": "deals",
    "active": true,
    "features": [
      {
        "title": "Deals",
        "name": "deals",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
   {
    "id":30,
    "title": "Reports",
    "module_name": "report",
    "active": true,
    "features": [
      {
        "title": "Reports",
        "name": "Reports",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
    {
    "id":31,
    "title": "Analytics",
    "module_name": "analytics",
    "active": true,
    "features": [
      {
        "title": "Analytics",
        "name": "Analytics",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 26,
    "title": "Forecast",
    "module_name": "forecast",
    "active": true,
    "features": [
      {
        "title": "Forecast",
        "name": "forecast",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 22,
    "title": "Account",
    "module_name": "account",
    "active": true,
    "features": [
      {
        "title": "Account",
        "name": "account",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 23,
    "title": "Contacts",
    "module_name": "contacts",
    "active": true,
    "features": [
      {
        "title": "Contacts",
        "name": "contacts",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
   {
    "id": 23,
    "title": "Products",
    "module_name": "product",
    "active": true,
    "features": [
      {
        "title": "Products",
        "name": "product",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 4,
    "title": "User Logs",
    "module_name": "user_log",
    "active": true,
    "features": [
      {
        "title": "User Logs",
        "name": "user_log",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 5,
    "title": "Campaign",
    "module_name": "campaign",
    "active": true,
    "features": [
      {
        "title": "Campaign",
        "name": "campaign",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  },
  {
    "id": 6,
    "title": "Settings",
    "module_name": "setting",
    "active": true,
    "features": [
      {
        "title": "Users",
        "name": "user",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
       {
        "title": "Manage Teams",
        "name": "manage_teams",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Pipeline",
        "name": "pipeline",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Email Settings",
        "name": "email_setting",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
       {
        "title": "Email Sequence",
        "name": "email_sequence",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "WhatsApp Template",
        "name": "whatsapp_template",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Email Template",
        "name": "email_template",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Contact Group",
        "name": "contact_group",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Schedule Settings",
        "name": "schedule_setting",
        "active": false,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Domain Authentication",
        "name": "domain_authentication",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
      {
        "title": "Leads field Settings",
        "name": "leads_field_setting",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      },
       {
        "title": "Category",
        "name": "category",
        "active": true,
        "update": true,
        "create": true,
        "delete": true
      }
    ]
  }
]

  constructor(private fb: FormBuilder,
    private api : RoleService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.permissionForm = this.fb.group({
      role_name : ['', Validators.required],
      permissions: this.fb.array([]),
      client_id: [this.clientId]
    });

    this.setPermissions(this.permissionsData);

    if (this.type === 'Update' && this.roleDataToEdit) {
      this.permissionForm.patchValue({
        role_name: this.roleDataToEdit.role_name,
        client_id: this.clientId
      });
      this.setPermissions(this.roleDataToEdit.permissions);
    }
  }

  get permissions(): FormArray {
    return this.permissionForm.get('permissions') as FormArray;
  }

  setPermissions(permissions: any[]): void {
    const permissionFGs = permissions.map(permission =>
      this.fb.group({
        id: [permission.id],
        title: [permission.title],
        module_name: [permission.module_name],
        active: [permission.active],
        features: this.fb.array(
          permission.features.map((feature: any) => this.createFeatureGroup(feature))
        ),
      })
    );
    this.permissions.clear();
    permissionFGs.forEach(fg => this.permissions.push(fg));
  }

  createFeatureGroup(feature: any): FormGroup {
    const featureGroup = this.fb.group({});
    Object.entries(feature).forEach(([key, value]) => {
      featureGroup.addControl(key, new FormControl(value));
    });
    return featureGroup;
  }

  getFeatures(permissionIndex: number): FormArray {
    return this.permissions.at(permissionIndex).get('features') as FormArray;
  }

  onSubmit(): void {
    console.log(this.permissionForm.value);

    this.submitted = true;
    if (this.permissionForm.invalid) {
      return;
    }

    const payload : any = {
      role_name: this.permissionForm.value.role_name,
      permissions: this.permissionForm.value.permissions,
      client_id: this.clientId
    };
    this.loading = true;
    if (this.type === 'Create') {
      this.api.createRole(payload).subscribe({
        next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Role created successfully!'
            });
            this.handleCloseDialog();
            this.reload.emit();
            this.handleCloseDialog();
            this.loading = false;

        },
        error: (err: any) => {
            this.loading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to create role. Please try again.'
            });
        }
      }
      );
    } else {
      payload['id'] = this.roleDataToEdit.id; // Add the role ID for update
      payload['role_id'] = this.roleDataToEdit.role_id; // Add the role ID for update
      payload['client_id'] = this.roleDataToEdit.client_id; // Add the client ID for update
      this.api.updateRole(payload).subscribe({
        next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Role updated successfully!'
            });
            this.handleCloseDialog();
            this.reload.emit();
            this.loading = false;
        },
        error: (err: any) => {
            this.loading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to update role. Please try again.'
            });
        }
      });
    }

  }

  handleCloseDialog(): void {
    this.permissionForm.reset();
    this.submitted = false;
    this.close.emit();
  }
}
